import { render, staticRenderFns } from "./PersonelTurleriMatrisList.vue?vue&type=template&id=8c857968&scoped=true"
import script from "./PersonelTurleriMatrisList.vue?vue&type=script&lang=ts"
export * from "./PersonelTurleriMatrisList.vue?vue&type=script&lang=ts"
import style0 from "./PersonelTurleriMatrisList.vue?vue&type=style&index=0&id=8c857968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c857968",
  null
  
)

export default component.exports